import sectionStyle from "@src/assets/_libs/layout/_l-section.module.scss";
import lWrapperStyle from "@src/assets/_libs/layout/_l-wrapper.module.scss";
import mFormStyle from "@src/assets/_libs/module/_m-form.module.scss";
import { SubHeaderArea } from "@src/components/molecules/Common/SubHeaderArea";
import { ComponentProps } from "react";

export function AccountBeforeConfirmTemplate(props: {
  animation: any;
  next: ComponentProps<"button">;
  isLoading?: boolean;
  error?: string | null;
}) {
  return (
    <>
      <SubHeaderArea title="お申込み前のご確認" subtitle="お申込みの流れと、口座開設に必要な書類、情報をご説明いたします。" />

      {/* エラーメッセージを表示 */}
      {props.error && (
        <div className={lWrapperStyle["l-wrapper"]}>
          <p className="m-error-message m-bottom15">{props.error}</p>
        </div>
      )}

      <section className={sectionStyle["l-section"]}>
        <div className={`${mFormStyle["m-form-container"]} m-bottom-border-bloc`}>
          <div className={lWrapperStyle["l-wrapper"]}>
            <div className={mFormStyle["m-form-section__header"]}>
              <p className={mFormStyle["m-form-section__subtitle1"] + " m-bottom0"}>このお手続きでは、以下のお申込みを受付けております。</p>
            </div>
            {/* chukai-course_kubun_flagを後で追加する */}
            <h2 className={mFormStyle["m-form-section__title"]}>
              <small>総合取引口座の開設</small>
              <strong className="chukai-course_kubun">「ダイワ・ダイレクト」コースのみ</strong>
            </h2>
            <div className={mFormStyle["m-form-other"]}>
              <p className={mFormStyle["m-form-other__title"]}><span className="chukai-course_kubun_flag0">その他、</span>申込み可能なサービス等</p>
              <ul className={mFormStyle["m-form-other__list"]}>
                <li className="">「オンライントレード」・「eメンバー」（必須）</li>
                <li className="chukai-nisa_flag">NISA口座の申込み（選択可）</li>
                <li className="chukai-nextbank_flag">大和ネクスト銀行口座開設（選択可）</li>
                <li className="chukai-specific_account_flag">特定口座のお申込み（選択可）</li>
              </ul>
            </div>

            <div className={mFormStyle["m-form-section__header"]}>
              <h2 className={mFormStyle["m-form-title1"] + " m-bottom20"}>お申込みの流れ</h2>
              <p className={mFormStyle["m-form-subtitle1"] + " m-bottom0"}>本申込みは以下の流れで進みます。<br className="nopc" />必要書類をご準備の上、申込みを進めてください。</p>
            </div>

            <div className={mFormStyle["m-form-subscription__flow"]}>
              {/* m-bottom20を追加する */}
              <ul className={mFormStyle["m-form-subscription__flow-list"] + " m-bottom20"}>
                <li className="">
                  <div className={mFormStyle["phase-icon"]}></div>
                  <div className={mFormStyle["list-contents"]}>
                    <div className={mFormStyle["list-icon"]}>
                      <img src="/img/subscription-flow1.png" alt="規定等を確認し、メールアドレスを登録" className="nosp" />
                      <img src="/img/subscription-flow1_sp.png" alt="規定等を確認し、メールアドレスを登録" className="nopc" />
                    </div>
                    <p>規定等を確認し、メール<br className="nosp" />アドレスを登録</p>
                  </div>
                </li>

                <li>
                  <div className={mFormStyle["phase-icon"]}></div>
                  <div className={mFormStyle["list-contents"]}>
                    <div className={mFormStyle["list-icon"]}>
                      <img src="/img/subscription-flow3.png" alt="マイナアプリにてマイナンバーカードを読み取りご本人確認" className="nosp" />
                      <img src="/img/subscription-flow3_sp.png" alt="マイナアプリにてマイナンバーカードを読み取りご本人確認" className="nopc" />
                    </div>
                    <p><a href="https://www.daiwa.jp/jumppages/hub-outside.html?hub_url=https://services.digital.go.jp/mynaapp/" target="_blank" rel="noopener noreferrer" className="m-link m-blank_window mr-5">マイナアプリ</a>にて<br />マイナンバーカードを読み取りご本人確認</p>
                  </div>
                </li>
                <li>
                  <div className={mFormStyle["phase-icon"]}></div>
                  <div className={mFormStyle["list-contents"]}>
                    <div className={mFormStyle["list-icon"]}>
                      <img src="/img/subscription-flow2.png" alt="口座開設に必要な情報を入力" className="nosp" />
                      <img src="/img/subscription-flow2_sp.png" alt="口座開設に必要な情報を入力" className="nopc" />
                    </div>
                    <p>口座開設に必要な情報を入力</p>
                  </div>
                </li>
                <li>
                  <div className={mFormStyle["phase-icon"]}></div>
                  <div className={mFormStyle["list-contents"]}>
                    <div className={mFormStyle["list-icon"]}>
                      <img src="/img/subscription-flow4.png" alt="口座開設のお申込み完了" className="nosp" />
                      <img src="/img/subscription-flow4_sp.png" alt="口座開設のお申込み完了" className="nopc" />
                    </div>
                    <p>口座開設の<br className="nosp" />お申込み完了</p>
                  </div>
                </li>
              </ul>
            </div>

            <div className={`${mFormStyle["m-form-subscription__flow"]} + ${mFormStyle["m-bloc-naibu_text"]} m-bottom20 m-bloc-naibu_text`}>
              <h3 className={mFormStyle["m-form-title1_sub"]}>お申込み完了後の流れ</h3>
              <ul className={`${mFormStyle["m-form-subscription__flow-list"]} + ${mFormStyle["m-standard-flow"]} m-standard-flow`}>
                <li>「口座開設のお知らせ」メールの受取り</li>
                <li>マイナンバーの登録</li>
                <li>取引開始</li>
              </ul>
            </div>
          </div>
        </div>

        <div className={mFormStyle["m-form-container"]}>
          <div className={lWrapperStyle["l-wrapper"]}>
            <div className={mFormStyle["m-form-section__header"]}>
              <h2 className={mFormStyle["m-form-title1"] + " m-bottom20"}>お申込みに必要な書類等</h2>
              <p className={mFormStyle["m-form-subtitle1"] + " m-bottom0"}>お申込みには以下のものが必要となりますので、<br className="nopc" />ご準備のうえお手続きを進めてください。</p>
            </div>

            <div className={mFormStyle["m-form-docs"]}>
              <ol className={mFormStyle["m-form-docs__list"]}>
                <li>
                  <div className={mFormStyle["m-form-docs__title"]}>
                    <div className={mFormStyle["m-form-docs__title-icon"]}>
                      <img src="/img/docs-tab1.png" alt="お取引先金融機関名・支店名・口座番号" />
                    </div>
                    <p className={mFormStyle["m-form-docs__title-text"]}>お取引先金融機関名・支店名・口座番号</p>
                  </div>
                </li>
                <li>
                  <div className={mFormStyle["m-form-docs__title"]}>
                    <div className={mFormStyle["m-form-docs__title-icon"]}>
                      <img src="/img/mynumber_card.png" alt="マイナンバーカード（※）" />
                    </div>
                    <p className={mFormStyle["m-form-docs__title-text"]}>マイナンバーカード（※）<br />スマートフォン</p>
                  </div>
                  <div className={mFormStyle["m-form-docs__desc"]}>
                    <ul className={mFormStyle["m-form-vertical__list"]}>
                      <li className={mFormStyle["m-form-vertical__list-bottom"]}>
                        <div>
                          <p className="m-kome">
                            <span>電子証明書の登録及びパスワードが必要です。</span>
                            {/* <span>健康保険証の「被保険者等の記号・番号および保険者番号、QRコード」は、あらかじめマスキング（付箋等で隠す）等をしたうえで撮影してください。マスキング等されていない場合は、当社にて判読できないように処理いたします。</span> */}
                          </p>
                          <p className="m-kome">
                            <span>お申込み手続きにあたって、デジタル庁が提供する「マイナアプリ」のダウンロードが必要となります。<br /><a href="https://www.daiwa.jp/jumppages/hub-outside.html?hub_url=https://www.jpki.go.jp/prepare/pdf/nfclist.pdf" target="_blank" rel="noopener noreferrer" className="m-link m-blank_window mr-5">利用可能な端末についてはこちら</a></span>
                          </p>
                          {/* <p className="m-red-color m-kome">
                            <span>外国籍のお客さまは、必ず「在留カード」または「特別永住者証明書」をご用意ください。</span>
                          </p> */}
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>

              </ol>
              <p className="m-top15 m-kome">
                <span>入力途中での保存機能がないため、お時間に余裕をもって、お申込みください。</span>
                <span>同一入力画面にて一定時間経過しますと、エラーとなり、始めからお手続きが必要となりますのでご注意ください。</span>
                <span>当申込フォームは、個人情報を保護するためにSSL暗号化通信を行なっております。</span>
                <span>マイナアプリのメンテナンス時間はご本人確認およびマイナンバー登録をお申込いただけない場合がございます。</span>
              </p>
            </div>
          </div>
        </div>

        <div className={`${mFormStyle["m-form-container"]} p-bottom0`}>
          <div className={lWrapperStyle["l-wrapper"]}>
            <p className={`m-align-center ${lWrapperStyle["l-wrapper3"]} p-top30`}>
              <button
                {...props.next}
                className="m-button_red"
                disabled={props.isLoading}
              >
                {props.isLoading ? "処理中..." : "次へ進む"}
              </button>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
